import { createStore } from "redux";

import createRootReducer from "./root.reducer";
import assembleMiddleware from "./assemble-middleware";

export default (history) =>
  createStore(createRootReducer(history), {}, assembleMiddleware(history));
